export default __webpack_public_path__ + "static/media/message.2fff3257.svg";